<template>
  <q-header elevated class="glossy">
    <q-toolbar>
      <q-btn
        flat
        dense
        round
        @click="clickLeftDrawer"
        aria-label="Menu"
        icon="menu"
      />

      <!-- <q-toolbar-title> Quasar App </q-toolbar-title>
       -->
      <!--
        notice shrink property since we are placing it
        as child of QToolbar
      -->
      <q-tabs v-model="tab" shrink>
        <q-route-tab :to="{ path: '/customer' }" name="tab1" label="ERP" @click="changeMenu(6)"/>
        <q-route-tab :to="{ path: '/mp/config' }" name="tab2" label="小程序" @click="changeMenu(7)"/>
        <q-route-tab :to="{ path: '/system' }" name="tab3" label="系统设置" @click="changeMenu(1)"/>
      </q-tabs>
      <q-space />
      <q-btn-dropdown stretch flat label="菜单">
        <q-list>
          <q-item-label header>Folders</q-item-label>
          <q-separator inset spaced />
          <q-item clickable v-close-popup tabindex="0">
            <!-- <q-item-section avatar>
              <q-avatar icon="power" color="secondary" text-color="white" />
            </q-item-section> -->
            <q-item-section @click="logout">
              <q-item-label>退出</q-item-label>
              <!-- <q-item-label caption>February 22, 2016</q-item-label> -->
            </q-item-section>
            <q-item-section side>
              <q-icon name="power" />
            </q-item-section>
          </q-item>
        </q-list>
      </q-btn-dropdown>
      <!-- <div>Quasar v{{ $q.version }}</div> -->
    </q-toolbar>
  </q-header>
</template>

<script>
export default {
  data() {
    return { tab: "tab1" };
  },

  methods: {
    clickLeftDrawer() {
      this.$emit("clickLeftDrawer");
    },
    logout() {
      this.$store.commit("clearToken");
      this.$router.push("/login");
    },
    changeMenu(parentId){
      this.$emit("changeMenu",parentId);
    }
  },
};
</script>

<style>
</style>